import type { PromoApplied, PromoAppliedOption } from "src/types/dom";

export const dispatchAnalyticsEvent = (promo: string, option: PromoAppliedOption) => {
  const promoAppliedEvent = new CustomEvent<PromoApplied>("promo-applied", {
    detail: {
      option,
      promo,
    },
  });
  document.dispatchEvent(promoAppliedEvent);
};